import React, {useEffect} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { PrintHOC } from '../../../components/prints/print.hoc'
import * as PrintHelpers from '../../../components/prints/utils'
import {useDispatch, useSelector} from "react-redux";
import {getLists} from "../../../state/lists";

const borderStyle = { border: '1px solid #424242', paddingTop: '10px' }
export const DeliveryPrintReport = ({ ticket, children }) => {
  let { delivery } = ticket
   const dispatch = useDispatch()
   const { gsx_repair_type ,coverage_type} = useSelector((state) => state.lists)
  const loadOptions = () => {
    !gsx_repair_type && dispatch(getLists('GSX_REPAIR_TYPE'))
    !coverage_type && dispatch(getLists('COVERAGE_TYPE'))
  }
  useEffect(() => {
    loadOptions()
  }, []);

  const { organization, device, customer, terms, gsx_information } = ticket
  if (!delivery) {
    delivery = {}
  }
  return (
    <ReactBootstrap.Row  className="p-2 print_zone">
      <ReactBootstrap.Col xs="12" className="p-0 mb-2 text-end d-print-none">
        <span className="pr-3">{children}</span>
      </ReactBootstrap.Col>
      <ReactBootstrap.Row className="pl-5 pr-5">
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.Header
            legend="Delivery Report"
            organization={organization}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.EaseOnBarcode value={ticket.reference_number} />
          <p>
            <PrintHelpers.Label value="GSX Reference Number"></PrintHelpers.Label>
            {gsx_information
              .filter((e) => !e.is_deleted)
              .map((e) => e.gsx_reference_number)
              .join(',')}
          </p>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.TimeStamp
            label="Received On"
             value={ticket.inward_time || ticket.created_at}
          />
          <PrintHelpers.TimeStamp
            label="Repair Close Time"
            value={ticket.closed_on}
          />
          <PrintHelpers.TimeStamp
            label="Device PickUp Time"
            value={delivery.device_pickup_time}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.Device label="Device Information" value={device} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.Organization
            label="Authorised Service Provider"
            value={organization}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.Customer
            label="Customer Information"
            value={customer}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.InlineText
            label="Issue Reported By Customer"
            lineBreakAfterLabel={true}
            value={ticket.issue_reported_by_customer}
          />

          <PrintHelpers.InlineText
            label="Service Type"
            lineBreakAfterLabel={true}
            value={gsx_information
              .filter((line) => !line.is_deleted)
              .map((line) => line.gsx_service_type)
                .map(y=>coverage_type?.filter
              (x=>x.code===y)[0]?.value)
              .join(',') || ticket.coverage_type}
          />
          <PrintHelpers.InlineText
            label="GSX Repair Type"
            lineBreakAfterLabel={true}
            value={gsx_information
              .filter((line) => !line.is_deleted)
              .map((line) => line.gsx_repair_type)
                .map(y=>gsx_repair_type?.filter
              (x=>x.code===y)[0]?.value)
              .join(',') || gsx_information
              .filter((line) => !line.is_deleted)
              .map((line) => line.gsx_repair_type)
              .join(',')}
          />
          <PrintHelpers.InlineText
            label="Outward Status"
            lineBreakAfterLabel={true}
            value={delivery.outward_condition}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.Label value={'Delivery Details'} />
          <PrintHelpers.InlineText
            label="Action Taken"
            lineBreakAfterLabel={true}
            value={delivery.action_taken}
          />
          {delivery.customer_feedback ? (
            <PrintHelpers.CustomerFeedback
              label="Customer Feedback"
              reports={delivery ? delivery.customer_feedback : {}}
            />
          ) : (
            <PrintHelpers.InlineText
              label="Customer Feedback"
              lineBreakAfterLabel={true}
              value="Customer feedback is not available."
            />
          )}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.DevicePartReport
            label="Device Part Information"
            reports={delivery ? delivery.unit_part_reports : {}}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>

          <PrintHelpers.Label value="Estimation Cost" />
          <PrintHelpers.Currency
            value={delivery.estimation_cost}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.InlineText
            label="Backup Required"
            lineBreakAfterLabel={true}
            value={ticket.is_backup_required ? 'Yes' : 'No'}
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.Label value="Total Service/Diagnosis Cost" />
          <PrintHelpers.Currency
            value={delivery.actual_service_cost + delivery.actual_hardware_cost}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.OrderLineTable
            label="Part/Serial Numbers Of new Device/Accessories"
            order_lines={ticket.order_lines}
            serializable_order_lines={ticket.serializable_order_lines}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.Terms label="Important" value={terms} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          {delivery.signature_authority_data && (
            <>
              <PrintHelpers.Signature
                signature={delivery.signature_authority_data.signature}
              />
              <PrintHelpers.InlineText
                value={delivery.signature_authority_data.name}
              />
            </>
          )}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className="text-end" style={borderStyle} xs={6}>
          <PrintHelpers.Signature signature={delivery.customer_signature2} />
          <PrintHelpers.InlineText value={'Customer Signature'} />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </ReactBootstrap.Row>
  )
}
export const DeliveryPrint = PrintHOC(DeliveryPrintReport)
